import React from "react";

import { MarkSvg } from "../styles";
import { MarkProps } from "../types";

/** Rising bars under a breakout line. */
const MomentumMark = ({ size, ...rest }: MarkProps) => (
  <MarkSvg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest}>
    <rect x="2" y="2" width="36" height="36" rx="8" fill="url(#bo-logo-momentum-bg)" />
    <rect x="9" y="25" width="4" height="5" rx="1.2" fill="#EDEEFA" opacity="0.92" />
    <rect x="15" y="20" width="4" height="10" rx="1.2" fill="#EDEEFA" opacity="0.92" />
    <rect x="21" y="15" width="4" height="15" rx="1.2" fill="#EDEEFA" opacity="0.92" />
    <rect x="27" y="11" width="4" height="19" rx="1.2" fill="#EDEEFA" opacity="0.92" />
    <path
      d="M9.5 17.5L15.4 13.2L20.2 16.4L29.8 8.6"
      stroke="#56C456"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5 8.4H30V13.9"
      stroke="#56C456"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="30" cy="8.5" r="2.4" fill="#FEB23A" />
    <defs>
      <linearGradient
        id="bo-logo-momentum-bg"
        x1="5"
        y1="5"
        x2="35"
        y2="35"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7748FC" />
        <stop offset="0.52" stopColor="#27B6E4" />
        <stop offset="1" stopColor="#182524" />
      </linearGradient>
    </defs>
  </MarkSvg>
);

export default MomentumMark;
